import type { HTMLAttributes } from "react";

export function Container({
  children,
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`d-flex-column gap-4m1 ${className}`} {...rest}>
      {children}
    </div>
  );
}
